import { c as _c } from "react/compiler-runtime";
import { RefObject, useCallback, useLayoutEffect, useState } from 'react';
import { useEventListener } from 'usehooks-ts';
type UseIframeSrcTeardownOptions = {
  teardownOnPopstate?: boolean;
};

/**
 * Own an iframe's source and unmount it when its ref cleans up.
 *
 * @param ref - The iframe element ref.
 * @param src - Pass `null` to opt out (URL not ready, or frame must stay resident).
 * @param options - Set `teardownOnPopstate` for browser-history teardown.
 */
export function useIframeSrcTeardown(ref, src, t0) {
  const $ = _c(13);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    teardownOnPopstate: t2
  } = t1;
  const teardownOnPopstate = t2 === undefined ? false : t2;
  const [iframeSrc, setIframeSrc] = useState(src);
  let t3;
  let t4;
  if ($[2] !== src) {
    t3 = () => {
      setIframeSrc(src);
    };
    t4 = [src];
    $[2] = src;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useLayoutEffect(t3, t4);
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setIframeSrc(null);
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const teardownIframe = t5;
  let t6;
  if ($[6] !== ref) {
    t6 = iframe => {
      ref.current = iframe;
      if (!iframe) {
        return;
      }
      return () => {
        teardownIframe();
        if (ref.current === iframe) {
          ref.current = null;
        }
      };
    };
    $[6] = ref;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const setIframeRef = t6;
  let t7;
  if ($[8] !== teardownOnPopstate) {
    t7 = () => {
      if (teardownOnPopstate) {
        teardownIframe();
      }
    };
    $[8] = teardownOnPopstate;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const handlePopstate = t7;
  useEventListener("popstate", handlePopstate);
  let t8;
  if ($[10] !== iframeSrc || $[11] !== setIframeRef) {
    t8 = {
      iframeSrc,
      setIframeRef,
      teardownIframe
    };
    $[10] = iframeSrc;
    $[11] = setIframeRef;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
}